import EditHeader from "common/components/EditHeader/EditHeader";
import HeaderButtonsEdit from "common/components/EditHeader/HeaderButtonsEdit";
import FormControl from "common/components/FormControl/FormControl";
import FormScrollError from "common/components/FormScrollError/FormScrollError";
import useRouter from "common/hooks/use-router";
import { useMemo, useState } from "react";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import arrayMutators from "final-form-arrays";

type ConfigurationFormProps = {
  configuration: any | undefined;
  configurationFields: any;
  onSubmit: (values: any) => any;
};

function ConfigurationForm({
  onSubmit,
  configuration,
  configurationFields,
}: ConfigurationFormProps) {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const { navigate } = useRouter();

  const initialValues = useMemo(
    () =>
      configuration?.id
        ? {
            ...configuration,
          }
        : {},
    [configuration]
  );

  const onSubmitWrapper = async (values: any) => {
    const res = await onSubmit(values);

    if (res.message) {
      setErrorMessage(res.message);
    }
  };

  const fieldFormControl = (fieldName: string, fieldType: any) => {
    return (
      <FormControl
        name={fieldName}
        title={t(`config.${fieldName}`)}
        type={
          fieldType.type === "boolean"
            ? "boolean"
            : fieldType.type === "integer" &&
              fieldName.toLowerCase().includes("price")
            ? "price"
            : undefined
        }
        required
      />
    );
  };

  return (
    <Form
      onSubmit={onSubmitWrapper}
      subscription={{ values: true, submitting: true, pristine: true }}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
        setFieldValue: ([f]: any, state: any, utils: any) => {
          utils.changeValue(state, f.field, () => f.value);
        },
      }}
      render={({ handleSubmit, values }) => {
        return (
          <div className="mx-auto max-w-full py-4 px-4 text-slate-500 text-base">
            {/* Header */}
            <EditHeader
              title="Configuration (réservé admin Juloa)"
              subTitle={values.name}
              icon="IoSettingsOutline"
              errorMessage={errorMessage}
              HeaderButtonsEdit={
                <HeaderButtonsEdit inHeader onSubmit={handleSubmit} />
              }
            />
            <form onSubmit={handleSubmit} noValidate>
              <FormScrollError />

              <div className="responsive-flex gap-2 mt-2">
                <div className="flex flex-row w-full gap-4 flex-wrap">
                  {Object.entries(configurationFields).map(
                    ([fieldName, field]) => (
                      <div key={fieldName} className="w-2/5">
                        {fieldFormControl(fieldName, field)}
                      </div>
                    )
                  )}
                </div>
              </div>
              <HeaderButtonsEdit
                onSubmit={handleSubmit}
                onCancel={() => navigate("/partners")}
              />
            </form>
          </div>
        );
      }}
    />
  );
}

export default ConfigurationForm;
